import { render, staticRenderFns } from "./CustomFieldLinkCards.vue?vue&type=template&id=8dbcdf70&scoped=true"
import script from "./CustomFieldLinkCards.vue?vue&type=script&lang=js"
export * from "./CustomFieldLinkCards.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldLinkCards.vue?vue&type=style&index=0&id=8dbcdf70&prod&scoped=true&lang=css"
import style1 from "./CustomFieldLinkCards.vue?vue&type=style&index=1&id=8dbcdf70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbcdf70",
  null
  
)

export default component.exports